import React, { useState } from "react";
import queries from "../helpers/queries";
import { withUser } from "../Contexts/user";
import ReactPlayer from "react-player";
import { FaPlay } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { useQuery } from "@apollo/react-hooks";

const Videos = () => {
    const [activeVideo, setActiveVideo] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [paginationState, setPaginationState] = useState({
        limit: 10,
        page: 1,
    });

    // Function to extract video ID from YouTube URL
    const getYouTubeVideoId = (url) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[2].length === 11 ? match[2] : null;
    };

    // Function to get YouTube thumbnail URL
    const getYouTubeThumbnail = (url) => {
        const videoId = getYouTubeVideoId(url);
        return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;
    };

    const { loading: videosLoading, data: videosData } = useQuery(
        queries.FETCH_VIDEOS,
        {
            variables: {
                limit: 8,
                page: paginationState.page,
            },
            fetchPolicy: "network-only",
            onCompleted: ({ fetchVideos: { pagination } }) =>
                setPaginationState(pagination),
        }
    );

    const handleVideoClick = (video) => {
        setActiveVideo(video);
        setShowModal(true);
    };

    return (
        <div className="videos-page">
            <div className="videos-container">
                <h1 className="videos-title">VIDEOS</h1>
                
                <div className="videos-grid">
                    {videosData?.fetchVideos.data.map((video) => {
                        const thumbnailUrl = getYouTubeThumbnail(video.url);
                        
                        return (
                            <div 
                                key={video._id} 
                                className="video-item"
                                onClick={() => handleVideoClick(video)}
                            >
                                <div 
                                    className="video-thumbnail"
                                    style={{
                                        background: thumbnailUrl 
                                            ? `url(${thumbnailUrl}) center/cover no-repeat`
                                            : '#f0f0f0'
                                    }}
                                >
                                    <div className="video-overlay">
                                        <i className="fas fa-play-circle video-play-icon"></i>
                                    </div>
                                    <div className="video-title">
                                        {video.name}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Pagination can be added here if needed */}
            </div>

            {/* Video Modal */}
            {showModal && (
                <div className="video-modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="video-modal-content" onClick={e => e.stopPropagation()}>
                        <button 
                            className="video-modal-close"
                            onClick={() => setShowModal(false)}
                        >
                            <FiX size={24} />
                        </button>
                        <ReactPlayer
                            url={activeVideo?.url}
                            width="100%"
                            height="100%"
                            controls={true}
                            playing={true}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default withUser(Videos);
